import { type ComponentProps } from 'react';

import { Button } from './Button';

export const OutlineButton = (props: Omit<ComponentProps<typeof Button>, 'variant'>) => (
  <Button {...props} variant="outline" />
);
